import { useEffect, useMemo, useRef, useState } from 'react'
import {
   Table,
   Space,
   Pagination,
   Input,
   Col,
   Row,
   Divider,
   Checkbox,
   Button,
   DatePicker,
   Select,
   Tooltip,
   InputNumber
} from 'antd'
import { create, isEmpty, remove, set, size, trim, uniq, uniqBy, uniqWith, reverse } from 'lodash'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../hooks'
import {
   DATE_FORMAT_CLIENT,
   DATE_TIME_FORMAT_CLIENT_short2,
   LIST_DELIVERY,
   ListStatusATG,
   ListStatusFW,
   ListStatusISO,
   OPERATOR,
   PAGE_SIZE,
   ROLES,
   SOCKET_EVENT,
   STATUS_ACTIVITY,
   TRACKING_STATUS_NAME,
   getPage,
   getStatusOrder,
   getVietnameseOrderState,
   statusOrder
} from '../../helpers/constants'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'

import moment from 'moment'
import 'moment/locale/vi'
import locale from 'antd/es/date-picker/locale/vi_VN'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { formatCurrency, getMilestoneValue } from 'src/helpers/functions'
import useModal from 'src/helpers/modal/useModal'
import CreateOrder from './Create'
import SelectProductModal from './SelectProductModal'
import AssignWarehouse from './AssignWarehouse'
import ExportToCSV from './ExportToCSV'
import { socket } from 'src/helpers/socket/socket'
import DeliveryDetailScreen from './DeliveryDetail'
import AssignDVVC from './AssignDVVC'
import DeliveryRoutingScreen from './DeliveryRouting'
import { useReactToPrint } from 'react-to-print'
import LabelPrint from 'src/common/components/LabelPrint'
import { useLocation } from 'react-router-dom'
import api from 'src/common/api'
import { Request2 } from 'src/common/Request2'
import { Loading } from 'src/common'
import UpdateStatusFF from './UpdateStatusFF'
import ImagePreview, { getImageUrl, isImageUrl } from 'src/common/components/ImagePreview'
import useTableScrollY from 'src/common/useTableScrollY'

function useQuery() {
   return new URLSearchParams(useLocation().search)
}

const OrderManagement = observer((props: any) => {
   const { t } = useTranslation()
   const OrdersStore = useStore('OrdersStore')
   const JobDetailStore = useStore('JobDetailStore')
   const UserStore = useStore('UserStore')
   const CommonConfigStore = useStore('CommonConfigStore')
   const AuthStore = useStore('AuthStore')
   const { data_getUserInfo } = AuthStore
   const [textSearch, set_textSearch] = useState('')
   const { paginationRef, scrollY, tableWrapperRef } = useTableScrollY({
      dependencyKey: `${OrdersStore.orders?.rows?.length || 0}-${OrdersStore.orders?.count || 0}`
   })
   const [visibleCreate, setVisibleCreate] = useState(false)
   const [visibleDetail, setVisibleDetail] = useState(false)
   const [visibleDetailDelivery, setVisibleDetailDelivery] = useState(false)
   const [visibleDeliveryRouting, setVisibleDeliveryRouting] = useState(false)
   const [visibleAssignWarehouse, setVisibleAssignWarehouse] = useState(false)
   const [visibleAssignDVVC, setVisibleAssignDVVC] = useState(false)
   const [visibleAssignStatusFF, setVisibleAssignStatusFF] = useState(false)
   const [selectedRow, setSelectedRow] = useState([])
   const [visibleProductModal, setVisibleProductModal] = useState(false)
   const [fieldFilter, setFieldFilter] = useState<any>({})
   const searchRef = useRef<any>(null)

   const [isLoading, setIsLoading] = useState(false)

   const [delivery, setDelivery] = useState<string>('')

   const [operator, setOperator] = useState<string>('')
   const [totalDelivery, setTotalDelivery] = useState<number | undefined>(0)
   const [deliveryOptions, setDeliveryOptions] = useState<any[]>(LIST_DELIVERY)
   const query = useQuery()
   const id = query.get('id') // lấy id từ url

   // const [startTime, setStartTime] = useState(moment().subtract(1, 'months'))
   // const [endTime, setEndTime] = useState(moment())
   // const [statusObj, setStatusObj] = useState<any>({
   //    new: [statusOrder.NEW], //new+renew
   //    accepted: [statusOrder.ACCEPTED],
   //    assignee: [statusOrder.ASSIGNEE],
   //    finish: [statusOrder.FINISH],
   //    // renew: [statusOrder.RE_NEW],
   //    cancel: [statusOrder.CANCEL]
   // })
   const { rows, offset, count } = OrdersStore.orders
   const [dataRow, setDataRow] = useState<any>([])
   const prevTextRef = useRef<string>('')
   const { rows: listFulfillment } = UserStore.listFulfillment
   const { rows: listSeller } = UserStore.listSeller
   const [selectedItem, setSelectedItem] = useState<any>([])
   const { confirm } = useModal()
   const { rows: tagList } = CommonConfigStore.tagList
   const [tags, setTags] = useState<any>([])

   const initSocket = async () => {
      await socket.connect()
   }

   const fetchDeliveryPartners = async () => {
      const apiList = await OrdersStore.getDeliveryPartnerList()
      if (apiList && apiList.length > 0) {
         const apiCodes = apiList.map((item: any) => item.code)
         const staticOnly = LIST_DELIVERY.filter((item: any) => !apiCodes.includes(item.value))
         const merged = [...apiList.map((item: any) => ({ value: item.code, label: item.label })), ...staticOnly]
         setDeliveryOptions(merged)
      }
   }

   const getDataDetail = async () => {
      try {
         const result = await OrdersStore.getDetail(id)
         setSelectedItem(result.order)
         const listProduct = formatDataProducts(result.listProductInOrder, result.order)
         OrdersStore.setProductsSelected(listProduct)
         setVisibleDetail(true)
      } catch (error) {
         console.error(error)
      }
   }
   useEffect(() => {
      if (!id) {
         return
      } else {
         getDataDetail()
      }
   }, [id])

   // useEffect(() => {
   //    // If the user cleared the search (transition from non-empty to empty), skip calling getListData
   //    const prevText = prevTextRef.current
   //    const nowEmpty = typeof textSearch === 'string' && textSearch.trim().length === 0
   //    const prevHadValue = typeof prevText === 'string' && prevText.trim().length > 0

   //    if (prevHadValue && nowEmpty) {
   //       // update prevTextRef for next render and skip API
   //       prevTextRef.current = textSearch
   //       return
   //    }

   //    // const statusResult = [
   //    //    ...statusObj.new,
   //    //    ...statusObj.accepted,
   //    //    ...statusObj.assignee,
   //    //    ...statusObj.cancel,
   //    //    // ...statusObj.renew,
   //    //    ...statusObj.finish
   //    // ].toString()

   //    getListData(0, {
   //       ...fieldFilter,
   //       // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
   //       // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
   //       // ...{ status: statusResult },
   //       ...{ keyword: textSearch }
   //    })
   //    // update prevTextRef after calling API
   //    prevTextRef.current = textSearch
   //    // JobsStore.getJobTotal(statusResult)
   //    // eslint-disable-next-line react-hooks/exhaustive-deps
   // }, [textSearch, fieldFilter, OrdersStore.startTime, OrdersStore.endTime])

   const handleGetData = (valueSearch = textSearch) => {
      getListData(0, {
         ...fieldFilter,
         // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // ...{ status: statusResult },
         ...{ keyword: valueSearch }
      })
   }

   useEffect(() => {
      if (data_getUserInfo?.role !== ROLES.SELLER) {
         getListSeller()
      }

      if (data_getUserInfo?.role == ROLES.FULFILLMENT) {
         getConfigFF()
      }

      if (data_getUserInfo?.role !== ROLES.FULFILLMENT) {
         getListFulfillment()
      }
      fetchDeliveryPartners()
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])
   useEffect(() => {
      initSocket()
      socket.on(SOCKET_EVENT.RELOAD_ORDER, (data) => {
         console.log('getListData(reload, 105')
         getListData(OrdersStore.offsetList / PAGE_SIZE, {
            ...fieldFilter,
            // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // ...{ status: statusResult },
            ...{ keyword: textSearch }
         })
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (tagList && tagList?.length > 0) {
         const tag = tagList.map((ro: any) => {
            return { id: ro?.id + '', name: ro?.name }
         })
         setTags(tag)
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [tagList])

   useEffect(() => {
      if (!tagList || tagList.length < 1) {
         const offset = getPage(0)
         const params = { offset, limit: 1000 }
         //  console.log('params', params)
         CommonConfigStore.getTagList(params)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])
   const getListFulfillment = async () => {
      try {
         // setIsLoading(true)
         const offset = getPage(0)
         const params = { offset }
         // console.log('params', params)

         await UserStore.getFulfillment(params)
      } catch (error) {
         // console.log(error)
      } finally {
      }
   }
   const getConfigFF = async () => {
      try {
         await UserStore.action_get_config()
      } catch (error) {
         // console.log(error)
      } finally {
      }
   }
   const getListSeller = async () => {
      try {
         // setIsLoading(true)
         const offset = getPage(0)
         const params = { offset }
         // console.log('params', params)

         await UserStore.getSeller(params)
      } catch (error) {
         // console.log(error)
      } finally {
      }
   }

   const getListData = async (currentPage: number, param?: any) => {
      try {
         // setIsLoading(true)
         const offset = getPage(currentPage, PAGE_SIZE)
         const params = { offset, ...param }

         const dataResult = await OrdersStore.getOrderList(params)

         const uniqueOrders = reverse(uniqBy(reverse([...dataRow, ...(dataResult.rows || [])]), 'id'))
         setDataRow(uniqueOrders)

         // Clear search input and restore focus safely for different ref shapes (DOM node or AntD input instance)
         try {
            if (searchRef && searchRef.current) {
               const ref = searchRef.current

               // AntD Input might expose `input` or be the DOM input itself
               ref.input.value = ''

               // Keep controlled state in sync if using textSearch state
               set_textSearch('')
            }
         } catch (e) {
            // ignore focus/clear errors
         }
      } catch (error) {
         // console.log(error)
      } finally {
         // setIsLoading(false)
      }
   }
   const onChange = (currentPage: number) => {
      // console.log('currentPage;', currentPage, 'currentPage-1', currentPage - 1)
      // const statusResult = [
      //    ...statusObj.new,
      //    ...statusObj.accepted,
      //    ...statusObj.assignee,
      //    ...statusObj.finish,
      //    // ...statusObj.renew,
      //    ...statusObj.cancel
      // ].toString()

      getListData(currentPage - 1, {
         ...fieldFilter,
         // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         ...{ keyword: trim(textSearch) }
         // ...{ status: statusResult }
      })
   }

   const handleChangeTextSearch = (value: any) => {
      // set_textSearch(value)
      // setTimeout(() => {
      if (value) {
         handleGetData(value)
      }

      // }, 1000)
   }

   const handleShowDetail = async (item: any) => {
      // setSelectedItem(item)
      try {
         const result = await OrdersStore.getDetail(item.id)
         setSelectedItem(result.order)
         const listProduct = formatDataProducts(result.listProductInOrder, result.order)
         OrdersStore.setProductsSelected(listProduct)
         setVisibleDetail(true)
      } catch (error) {
         console.error(error)
      }

      // setTimeout(() => {
      //    setVisibleDetail(true)
      // }, 500)
   }

   const hideDetail = () => {
      setVisibleDetail(false)
      setSelectedItem(null)
      OrdersStore.setProductsSelected([])
   }
   const handleEdit = () => {
      //gọi lại API list nếu cần sửa gì đó
      setVisibleDetail(false)
      setSelectedItem(null)
   }

   const handleOrderCreator = (isEdit: boolean = false) => {
      //gọi lại API list nếu cần sửa gì đó
      if (isEdit) {
         setVisibleDetail(false)
         setSelectedItem(null)
      } else {
         setVisibleCreate(false)
      }
      // const statusResult = [
      //    ...statusObj.new,
      //    ...statusObj.accepted,
      //    ...statusObj.assignee,
      //    // ...statusObj.renew,
      //    ...statusObj.cancel,
      //    ...statusObj.finish
      // ].toString()

      getListData(OrdersStore.offsetList / PAGE_SIZE, {
         ...fieldFilter,
         // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // ...{ status: statusResult },
         ...{ keyword: trim(textSearch) }
      })
   }

   const handleAssignDVVC = () => {
      //gọi lại API list nếu cần sửa gì đó

      setSelectedRow((prev) => prev.filter((item: any) => item.status !== statusOrder.ASSIGNEE))
      getListData(OrdersStore.offsetList / PAGE_SIZE, {
         ...fieldFilter,
         // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         ...{ keyword: trim(textSearch) }
      })
      setVisibleAssignDVVC(false)
   }

   const handleAssignStatusFF = () => {
      getListData(OrdersStore.offsetList / PAGE_SIZE, {
         ...fieldFilter,
         // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         ...{ keyword: trim(textSearch) }
      })
      setVisibleAssignStatusFF(false)
   }

   const handleAssignWarehouse = () => {
      //gọi lại API list nếu cần sửa gì đó

      setSelectedRow((prev) => prev.filter((item: any) => item.status !== statusOrder.ASSIGNEE))
      getListData(OrdersStore.offsetList / PAGE_SIZE, {
         ...fieldFilter,
         // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         ...{ keyword: trim(textSearch) }
      })
      setVisibleAssignWarehouse(false)
   }

   const onChangeStatus = (key: string | number, e: any) => {
      // let notOrder = OrderStore.optionSearchOrderCustomer.status.includes(1) ? [1] : []
      // let placingData = OrderStore.optionSearchOrderCustomer.status.includes(2) ? [2] : []
      // let orderFinish = OrderStore.optionSearchOrderCustomer.status.includes(3) ? [3] : []
      // let soldOut = OrderStore.optionSearchOrderCustomer.status.includes(4) ? [4] : []
      let statusNow = { ...OrdersStore.statusObj }
      switch (key) {
         case statusOrder.NEW:
            if (e.target.checked) {
               statusNow.new = [statusOrder.NEW]
               // statusNow.renew = [statusOrder.RE_NEW]
            } else {
               statusNow.new = []
               // statusNow.renew = []
            }
            break
         case statusOrder.ACCEPTED:
            if (e.target.checked) {
               statusNow.accepted = [statusOrder.ACCEPTED]
            } else {
               statusNow.accepted = []
            }
            break
         case statusOrder.ASSIGNEE:
            if (e.target.checked) {
               statusNow.assignee = [statusOrder.ASSIGNEE]
            } else {
               statusNow.assignee = []
            }
            break
         case statusOrder.FINISH:
            if (e.target.checked) {
               statusNow.finish = [statusOrder.FINISH]
            } else {
               statusNow.finish = []
            }
            break
         case statusOrder.CANCEL:
            if (e.target.checked) {
               statusNow.cancel = [statusOrder.CANCEL]
            } else {
               statusNow.cancel = []
            }
            break
         default:
            if (e.target.checked) {
               statusNow.finish = [statusOrder.FINISH]
            } else {
               statusNow.finish = []
               statusNow.cancel = []
            }
            break
      }
      OrdersStore.setStatusObj(statusNow)
      // let dataStatus = [...placingData, ...notOrder, ...orderFinish, ...soldOut]
      // OrderStore.setOptionSearchOrderCustomer({ status: dataStatus })

      const statusResult = [
         ...statusNow.new,
         ...statusNow.accepted,
         ...statusNow.assignee,
         // ...statusNow.renew,
         ...statusNow.cancel,
         ...statusNow.finish
      ].toString()
      console.log('statusNow: ', statusNow, 'statusResult; ', statusResult)
      setFieldFilter({ ...fieldFilter, ...{ status: statusResult } })
   }

   const handleExportExcel = async () => {
      try {
         const fileUrl = await OrdersStore.exportExcelV2({
            ...fieldFilter,
            ...{ keyword: trim(textSearch) }
         })

         let link = document.createElement('a')
         link.href = fileUrl as string
         link.setAttribute('download', 'orders.xlsx')
         document.body.appendChild(link)
         link.click()
         document.body.removeChild(link)
      } catch (error) {
         // console.log(error)
      } finally {
         // setIsLoading(false)
      }
   }

   const handlePriority = async (value: any, status: boolean, index: number) => {
      try {
         const res = await JobDetailStore.setJobPriority(value?.id, status)
         console.log('res', res)
         if (res) {
            // Sửa dữ liệu offline
            // JobsStore.action_updateJobPriority(index, status)
         }
      } catch (error) {
         console.log(error)
      } finally {
      }
   }

   const handleAssignSelected = () => {
      // alert('Tính năng đang phát triển')
      // return
      setVisibleAssignWarehouse(true)
   }

   const handlePushSelected = () => {
      console.log('selectedRow', selectedRow || [])
      const ids = (selectedRow || []).map((item: any) => {
         return item?.id
      })
      handlePushOrders(ids)
      // setVisibleAssignWarehouse(true)
   }
   const handleAssignDVVCSelected = () => {
      console.log('selectedRow', selectedRow || [])
      // const ids = (selectedRow || []).map((item: any) => {
      //    return item?.id
      // })
      // handlePushOrders(ids)
      // setVisibleDetailDelivery(true)
      setVisibleAssignDVVC(true)
   }

   const handleAssign = (value: any) => {
      let x: any = []
      x.push(value)
      setSelectedRow(x)
      setVisibleAssignWarehouse(true)
      // confirm({
      //    title: t(GLOBAL_CLIENT.banmuonhuyjob),
      //    icon: <ExclamationCircleOutlined />,
      //    okText: t(GLOBAL_CLIENT.dongy),
      //    cancelText: t(GLOBAL_CLIENT.huy),
      //    onCancel() {},
      //    async onOk() {
      //       // await JobsStore.cancelJob(value?.id)
      //       if (size(trim(textSearch)) > 0) {
      //          getListData(0, { ...fieldFilter, ...{ name: trim(textSearch) } })
      //       } else {
      //          getListData(0, { ...fieldFilter })
      //       }
      //    }
      // })
   }
   const handleAssignDelivery = () => {
      const isListConffirm = selectedRow.length > 1
      const listOrderSelected = selectedRow.map((row: any) => row.id)
      confirm({
         title: isListConffirm
            ? 'Bạn muốn đẩy các đơn đã chọn sang bên vận chuyển?'
            : 'Bạn muốn đẩy đơn sang bên vận chuyển?',
         icon: <ExclamationCircleOutlined />,
         okText: 'Xác nhận',
         cancelText: 'Từ chối',
         async onCancel() {},
         async onOk() {
            // await OrdersStore.confirmOrder({ reject: false, orderIds: listOrderSelected })
            await OrdersStore.confirmCreateDelivery(listOrderSelected)
            getListData(OrdersStore.offsetList / PAGE_SIZE, {
               ...fieldFilter,
               ...{ keyword: textSearch }
            })
         }
      })
   }

   // const handlePrintLabel = () => {
   //    console.log('selectedRow',JSON.stringify(selectedRow));
   //    if(selectedRow &&selectedRow.length>0){
   //       //TODO print list label
   //    }
   // }

   const contentRef = useRef<HTMLDivElement>(null)

   // const handlePrintLabel = useReactToPrint({
   //    // @ts-expect-error type chưa update
   //    contentRef: () => componentRef, // ✅ vẫn chạy được
   //    documentTitle: 'Label List',
   //    removeAfterPrint: true
   // })

   const handleShowPrint = useReactToPrint({ contentRef })

   const handlePrintLabel = async () => {
      try {
         setIsLoading(true)
         let dataBody: any = []

         selectedRow.map((item: any) => {
            (item?.products_orders || []).map((product: any) => {
               dataBody.push({
                  linkMockup: product?.linkMockup || item?.linkMockup,
                  sellerOrderId: item?.sellerOrderId,
                  products: (item?.products_orders || [])
                     .map((product: any) => product?.product?.name + `(${product?.qty})`)
                     .join(', '),
                  quantity: product?.qty,
                  totalQuantity: (item?.products_orders || []).reduce(
                     (acc: any, product: any) => acc + product?.qty,
                     0
                  ),
                  product: product?.product?.name,
                  createdAt: moment(item?.createdAt).format('DD/MM/YYYY HH:mm'),
                  note: item?.note,
                  services: (item?.serviceOrders || [])
                     .map((service: any) => service?.serviceName + `(${service?.qty})`)
                     .join(', '),
                  deliveryPartner: item?.deliveryPartner,
                  id: item?.id
               })
            })
         })

         const convertData = await Request2.post({ data: dataBody }, api.orderv2.getLabel)

         if (convertData?.data && convertData?.data.length > 0) {
            let dataDone: any = []
            convertData?.data?.map((v2: any) => {
               for (let index = 1; index <= v2.quantity; index++) {
                  dataDone.push(v2)
               }
            })
            setSelectedRow(dataDone)
            setTimeout(() => {
               handleShowPrint()
            }, 500)
         }
      } catch (error) {
         setIsLoading(false)
      } finally {
         setIsLoading(false)
      }
   }

   const handlePrint = async () => {
      const isListConffirm = selectedRow.length > 1
      const listOrderSelected = selectedRow.map((row: any) => row.id)
      const file = await OrdersStore.getPdf(listOrderSelected)

      if (file) {
         // Mở file PDF trong cửa sổ mới
         const pdfWindow = window.open(file)

         // Sau khi cửa sổ tải xong, gọi hàm in
         pdfWindow?.addEventListener('load', () => {
            pdfWindow?.print()
         })
      }
   }

   const handleConfirmOrder = (value: any) => {
      const isListConffirm = selectedRow.length > 1
      const listOrderSelected = selectedRow.map((row: any) => row.id)
      confirm({
         title: isListConffirm ? 'Bạn muốn xác nhận những đơn hàng đã chọn?' : 'Bạn muốn xác nhận đơn hàng?',
         icon: <ExclamationCircleOutlined />,
         okText: 'Xác nhận',
         cancelText: 'Từ chối',
         async onCancel() {
            await OrdersStore.confirmOrder({ reject: true, orderIds: listOrderSelected })
            // const statusResult = [
            //    ...statusObj.new,
            //    ...statusObj.accepted,
            //    ...statusObj.assignee,
            //    // ...statusObj.renew,
            //    ...statusObj.cancel,
            //    ...statusObj.finish
            // ].toString()

            getListData(OrdersStore.offsetList / PAGE_SIZE, {
               ...fieldFilter,
               // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
               // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
               // ...{ status: statusResult },
               ...{ keyword: textSearch }
            })
         },
         async onOk() {
            await OrdersStore.confirmOrder({ reject: false, orderIds: listOrderSelected })
            // const statusResult = [
            //    ...statusObj.new,
            //    ...statusObj.accepted,
            //    ...statusObj.assignee,
            //    // ...statusObj.renew,
            //    ...statusObj.cancel,
            //    ...statusObj.finish
            // ].toString()

            getListData(OrdersStore.offsetList / PAGE_SIZE, {
               ...fieldFilter,
               // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
               // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
               // ...{ status: statusResult },
               ...{ keyword: textSearch }
            })
         }
      })
   }
   const handleCancelOrder = (value: any) => {
      confirm({
         title: 'Bạn xác nhận huỷ đơn hàng?',
         icon: <ExclamationCircleOutlined />,
         okText: 'Xác nhận',
         cancelText: 'Huỷ',
         async onCancel() {},
         async onOk() {
            await OrdersStore.cancelOrder(value?.id)
            // const statusResult = [
            //    ...statusObj.new,
            //    ...statusObj.accepted,
            //    ...statusObj.assignee,
            //    // ...statusObj.renew,
            //    ...statusObj.cancel,
            //    ...statusObj.finish
            // ].toString()

            getListData(OrdersStore.offsetList / PAGE_SIZE, {
               ...fieldFilter,
               // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
               // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
               // ...{ status: statusResult },
               ...{ keyword: textSearch }
            })
         }
      })
   }
   const handleCompleteOrder = async (value: any) => {
      await OrdersStore.finishOrder(value?.id, {})
      // const statusResult = [
      //    ...statusObj.new,
      //    ...statusObj.accepted,
      //    ...statusObj.assignee,
      //    // ...statusObj.renew,
      //    ...statusObj.cancel,
      //    ...statusObj.finish
      // ].toString()

      if (size(trim(textSearch)) > 0) {
         getListData(OrdersStore.offsetList / PAGE_SIZE, {
            ...fieldFilter,
            // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // ...{ status: statusResult },
            ...{ keyword: trim(textSearch) }
         })
      } else {
         getListData(OrdersStore.offsetList / PAGE_SIZE, {
            ...fieldFilter,
            // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // ...{ status: statusResult },
            ...{ keyword: trim(textSearch) }
         })
      }
   }

   const formatDataProducts = (list: any, order?: any) => {
      return (list || []).map((item: any) => {
         const product = item?.product || item
         return {
            name: product?.name,
            id: product?.id,
            images: product?.images,
            base_cost: item?.baseCostSellter || product?.base_cost,
            qty: item?.qty,
            tags: product?.tags,
            linkMockup: item?.linkMockup || item?.mockup || product?.linkMockup || order?.linkMockup || '',
            linkDesign: item?.linkDesign || item?.design || product?.linkDesign || order?.linkDesign || ''
         }
      })
   }

   const getProductsInOrder = (record: any) => {
      const productSources = [record?.listProduct, record?.products_orders, record?.listProductInOrder]
      return productSources.find((source) => Array.isArray(source) && source.length > 0) || []
   }

   const getProductLink = (item: any, record: any, field: 'linkMockup' | 'linkDesign') => {
      const product = item?.product || item
      const link = item?.[field] || product?.[field] || record?.[field] || ''
      return typeof link === 'string' ? link.trim() : ''
   }

   const renderProductRows = (record: any, type: 'product' | 'mockup' | 'design') => {
      const products = getProductsInOrder(record)

      if (products.length === 0) return <span>--</span>

      return (
         <div className="order-product-list">
            {products.map((item: any, index: number) => {
               const product = item?.product || item
               const field = type === 'mockup' ? 'linkMockup' : 'linkDesign'
               const link = type === 'product' ? '' : getProductLink(item, record, field)

               return (
                  <div className="order-product-row" key={`${type}-${product?.id || index}`}>
                     {type === 'product' && (
                        <>
                           <ImagePreview
                              src={getImageUrl(product?.images?.[0] || '', process.env.REACT_APP_IMAGE_ENDPOINT)}
                              size={64}
                              fit="contain"
                           />
                           <span className="txtMax2Line order-product-name">{product?.name}</span>
                        </>
                     )}

                     {type !== 'product' &&
                        (link ? (
                           isImageUrl(link) ? (
                              <ImagePreview src={link} size={64} fit="contain" />
                           ) : (
                              <a href={link} target="_blank" rel="noreferrer" className="gx-link order-link-text">
                                 {link}
                              </a>
                           )
                        ) : (
                           <span>--</span>
                        ))}
                  </div>
               )
            })}
         </div>
      )
   }

   const handleRemoveOrder = async (id: string) => {
      try {
         await OrdersStore.removeOrder(id)

         // const statusResult = [
         //    ...statusObj.new,
         //    ...statusObj.accepted,
         //    ...statusObj.assignee,
         //    // ...statusObj.renew,
         //    ...statusObj.cancel,
         //    ...statusObj.finish
         // ].toString()

         setVisibleDetail(false)

         getListData(OrdersStore.offsetList / PAGE_SIZE, {
            ...fieldFilter,
            // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // ...{ status: statusResult },
            ...{ keyword: textSearch }
         })
      } catch (error) {}
   }

   const handlePushOrder = async (id: string) => {
      try {
         let ids = []
         ids.push(id)
         await OrdersStore.pushOrders(ids)

         // const statusResult = [
         //    ...statusObj.new,
         //    ...statusObj.accepted,
         //    ...statusObj.assignee,
         //    // ...statusObj.renew,
         //    ...statusObj.cancel,
         //    ...statusObj.finish
         // ].toString()

         getListData(OrdersStore.offsetList / PAGE_SIZE, {
            ...fieldFilter,
            // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // ...{ status: statusResult },
            ...{ keyword: textSearch }
         })
      } catch (error) {}
   }

   const handleShowDetailDelivery = (value: any) => async () => {
      console.log(value)
      switch (value?.deliveryPartner) {
         case 'ATD':
            if (value?.deliveryState) {
               setVisibleDetailDelivery(true)
               setSelectedItem([value])
            }
            break

         case 'FW':
            const dataRouting = await OrdersStore.getRoutingFW({ deliveryId: value?.deliveryId })
            setSelectedItem(dataRouting?.data || [])
            setVisibleDeliveryRouting(true)

            break
      }
   }

   const handlePushOrders = async (ids: any) => {
      try {
         await OrdersStore.pushOrders(ids)

         // const statusResult = [
         //    ...statusObj.new,
         //    ...statusObj.accepted,
         //    ...statusObj.assignee,
         //    // ...statusObj.renew,
         //    ...statusObj.cancel,
         //    ...statusObj.finish
         // ].toString()

         getListData(OrdersStore.offsetList / PAGE_SIZE, {
            ...fieldFilter,
            // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
            // ...{ status: statusResult },
            ...{ keyword: textSearch }
         })
      } catch (error) {}
   }

   const fetchListData = () => {
      // const statusResult = [
      //    ...statusObj.new,
      //    ...statusObj.accepted,
      //    ...statusObj.assignee,
      //    // ...statusObj.renew,
      //    ...statusObj.cancel,
      //    ...statusObj.finish
      // ].toString()
      console.log('getListData(0, 641')

      getListData(OrdersStore.offsetList / PAGE_SIZE, {
         ...fieldFilter,
         // from: moment(startTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // to: moment(endTime).format(DATE_FORMAT_CLIENT_PARAMS).toString(),
         // ...{ status: statusResult },
         ...{ keyword: textSearch }
      })
   }

   let columns = [
      {
         title: 'OrderID',
         dataIndex: 'code',
         key: 'code',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
         // fixed: 'left',
      },
      {
         title: 'Created',
         dataIndex: 'createdAt',
         key: 'createdAt',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{moment(value).format(DATE_TIME_FORMAT_CLIENT_short2)}</span>
         }
      },
      {
         title: 'Products',
         dataIndex: 'listProduct',
         key: 'listProduct',
         width: 130,
         render: (_: any, record: any) => renderProductRows(record, 'product')
      },
      {
         title: 'Link mockup',
         dataIndex: 'listProduct',
         width: 220,
         key: 'linkMockup',
         render: (_: any, record: any) => renderProductRows(record, 'mockup')
      },
      {
         title: 'Link design',
         dataIndex: 'listProduct',
         width: 220,
         key: 'linkDesign',
         render: (_: any, record: any) => renderProductRows(record, 'design')
      },
      {
         title: 'Updated',
         dataIndex: 'updatedAt',
         key: 'updatedAt',
         width: 80,
         render: (value: any) => {
            return <span className="txtMax2Line">{moment(value).format(DATE_TIME_FORMAT_CLIENT_short2)}</span>
         }
      },
      {
         title: 'Seller OrderID',
         dataIndex: 'sellerOrderId',
         key: 'sellerOrderId',
         width: 140,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'QTY',
         dataIndex: 'qty',
         width: 50,
         key: 'qty',
         render: (value: any) => {
            return <span className="xtMax2Line">{value}</span>
         }
         // render: (value: any) => {
         //    return <span className="txtMax2Line">{value?.name || ''}</span>
         // }
      },
      {
         title: 'Ship to',
         dataIndex: 'qty',
         width: 150,
         key: 'qty',
         render: (value: any, record: any) => {
            return record?.shipLabel ? (
               <a href={`${record?.shipLabel}`} target="_blank" rel="noreferrer">
                  <span className="gx-link txtMax2Line" style={{ fontSize: 11 }}>
                     {record?.shipLabel}
                  </span>
               </a>
            ) : (
               <div style={{ fontSize: 11 }}>
                  <div>
                     Customer:{' '}
                     <span className="gx-link txtMax2LineHover" style={{ fontSize: 11 }}>
                        {record?.customer}
                     </span>
                  </div>
                  <div>
                     Phone:{' '}
                     <span className="gx-link txtMax2LineHover" style={{ fontSize: 11 }}>
                        {record?.phone}
                     </span>
                  </div>
                  <div>
                     Address:{' '}
                     <span className="gx-link txtMax2LineHover" style={{ fontSize: 11 }}>{`${record?.address1 || ''}${
                        record?.address2 ? `- ${record?.address2}` : ''
                     } - ${record?.city} - ${record?.state} - ${record?.zipCode}`}</span>
                  </div>
                  {/* <div>
                     Address1:{' '}
                     <span
                        className="gx-link txtMax2LineHover"
                        style={{ fontSize: 11 }}
                     >{`${record?.address1}`}</span>
                  </div> */}
               </div>
            )
         }
         // render: (value: any) => {
         //    return <span className="txtMax2Line">{value?.name || ''}</span>
         // }
      },
      {
         title: 'Note',
         dataIndex: 'note',
         width: 80,
         key: 'note',
         render: (value: any) => {
            return <span className="xtMax2Line">{value && value.length > 20 ? value.slice(0, 20) + '...' : value}</span>
         }
      },
      {
         title: 'Dịch vụ',
         dataIndex: 'serviceOrders',
         width: 120,
         key: 'serviceOrders',
         render: (value: any) => {
            if (!value || value.length === 0) return <span>--</span>
            return (
               <div style={{ fontSize: 11 }}>
                  {value.map((s: any, index: number) => (
                     <div key={index} className="txtMax2Line">
                        {s.qty > 1 ? `(${s.qty})` : ''} {s.serviceName}
                     </div>
                  ))}
               </div>
            )
         }
      }
      // {
      //    title: 'Base cost',
      //    dataIndex: 'packingFee',
      //    width: 80,
      //    key: 'packingFee',
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{formatCurrency(value, true)}$</span>
      //    }
      // },
      // {
      //    title: 'Shipping cost',
      //    dataIndex: 'shippingFee',
      //    width: 80,
      //    key: 'shippingFee',
      //    render: (value: any) => {
      //       return <span className="txtMax2Line">{formatCurrency(value, true)}$</span>
      //    }
      // },
   ]
   let col2 = [] as any
   if (data_getUserInfo?.role === ROLES.ADMIN) {
      col2 = [
         {
            title: 'Total Seller',
            dataIndex: 'subTotalPrice',
            width: 80,
            key: 'subTotalPrice',
            render: (value: any, record: any) => {
               return <span className="txtMax2Line">${formatCurrency(value)}</span>
            }
         },
         {
            title: 'Total Fulfillment',
            dataIndex: 'subTotalPriceFullfiment',
            width: 80,
            key: 'subTotalPriceFullfiment',
            render: (value: any, record: any) => {
               return <span className="txtMax2Line">${formatCurrency(value)}</span>
            }
         },
         {
            title: 'Seller',
            dataIndex: 'account',
            width: 80,
            key: 'account',
            render: (value: any) => {
               return <span className="txtMax2Line">{value?.name}</span>
            }
         },
         {
            title: 'Fulfillment',
            dataIndex: 'store',
            width: 80,
            key: 'store',
            render: (value: any) => {
               return <span className="txtMax2Line">{value?.name}</span>
            }
         },
         {
            title: 'DVVC',
            dataIndex: 'deliveryPartner',
            width: 80,
            key: 'deliveryPartner',
            render: (value: any) => {
               return <span className="txtMax2Line">{value}</span>
            }
         },
         {
            title: 'Toàn trình',
            // Nếu đã giao thành công (getMilestoneValue('Delivered', ...) có giá trị):
            // → Tính số ngày từ createdAt đến ngày Delivered.
            // Nếu chưa giao:
            // → Tính số ngày từ createdAt đến ngày hiện tại.
            dataIndex: 'tracking',
            width: 80,
            key: 'tracking',
            render: (value: any, record: any) => {
               const deliveredDate = getMilestoneValue('Delivered', value?.data?.milestone)
               const createDate = record?.createdAt

               const start = moment(createDate)
               const end = deliveredDate ? moment(deliveredDate, 'YYYY-MM-DDTHH:mm:ssZ') : moment()

               const duration = end.diff(start, 'days')

               return <span className="txtMax2Line">{duration} ngày</span>
            }
         }
      ]
   }
   if (data_getUserInfo?.role === ROLES.SELLER) {
      col2 = [
         {
            title: 'Total',
            dataIndex: 'subTotalPrice',
            width: 80,
            key: 'subTotalPrice',
            render: (value: any, record: any) => {
               return <span className="txtMax2Line">${formatCurrency(value)}</span>
            }
         }
      ]
   }
   if (data_getUserInfo?.role === ROLES.FULFILLMENT) {
      col2 = [
         {
            title: 'Total Fulfillment',
            dataIndex: 'subTotalPriceFullfiment',
            width: 80,
            key: 'subTotalPriceFullfiment',
            render: (value: any, record: any) => {
               return <span className="txtMax2Line">${formatCurrency(value)}</span>
            }
         },
         {
            title: 'DVVC',
            dataIndex: 'deliveryPartner',
            width: 80,
            key: 'deliveryPartner',
            render: (value: any) => {
               return <span className="txtMax2Line">{value}</span>
            }
         }
      ]
   }

   if (data_getUserInfo?.role === ROLES.MANAGER_ORDER) {
      col2 = [
         {
            title: 'Seller',
            dataIndex: 'account',
            width: 80,
            key: 'account',
            render: (value: any) => {
               return <span className="txtMax2Line">{value?.name}</span>
            }
         },
         {
            title: 'DVVC',
            dataIndex: 'deliveryPartner',
            width: 80,
            key: 'deliveryPartner',
            render: (value: any) => {
               return <span className="txtMax2Line">{value}</span>
            }
         },
         {
            title: 'Toàn trình',
            // Nếu đã giao thành công (getMilestoneValue('Delivered', ...) có giá trị):
            // → Tính số ngày từ createdAt đến ngày Delivered.
            // Nếu chưa giao:
            // → Tính số ngày từ createdAt đến ngày hiện tại.
            dataIndex: 'tracking',
            width: 80,
            key: 'tracking',
            render: (value: any, record: any) => {
               const deliveredDate = getMilestoneValue('Delivered', value?.data?.milestone)
               const createDate = record?.createdAt

               const start = moment(createDate)
               const end = deliveredDate ? moment(deliveredDate, 'YYYY-MM-DDTHH:mm:ssZ') : moment()

               const duration = end.diff(start, 'days')

               return <span className="txtMax2Line">{duration} ngày</span>
            }
         }
      ]
   }

   let colDelivery: any[] = []
   if (data_getUserInfo?.role === ROLES.FULFILLMENT && data_getUserInfo?.isDelivery) {
      colDelivery = [
         {
            title: 'Status Delivery',
            dataIndex: 'deliveryState',
            width: 80,
            key: 'deliveryState',
            render: (value: any, record: any) => {
               return (
                  <span
                     onClick={handleShowDetailDelivery(record)}
                     style={{ color: value ? '#038fde' : 'red', cursor: 'pointer' }}
                     className="txtMax2Line"
                  >
                     <Tooltip placement="top" title={record?.deliveryError || ''}>
                        {value ? getVietnameseOrderState(value) : record?.deliveryError}
                     </Tooltip>
                  </span>
               )
            }
         }
      ]
   }

   let col3 = [
      {
         title: 'Tracking ID',
         dataIndex: 'trackingId',
         width: 95,
         key: 'trackingId',
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'Tracking status',
         dataIndex: 'trackingStatusName',
         width: 80,
         key: 'trackingStatusName',
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },

      {
         title: 'Order status',
         dataIndex: 'status',
         width: 80,
         key: 'status',
         render: (value: any, record: any) => {
            return <span className="txtMax2Line">{getStatusOrder(value, record)}</span>
         }
      },
      {
         title: 'Action',
         key: 'action',
         width: 150,
         align: 'center' as 'center',
         fixed: 'right' as 'right',
         render: (text: string, record: any, index: number) => {
            return record?.isPending ? (
               <span onClick={() => handleShowDetail(record)} className="gx-link txtMax3LineHover">
                  {t(GLOBAL_CLIENT.detail)}
               </span>
            ) : (
               <>
                  <span className="txtMax3LineHover">
                     <span onClick={() => handleShowDetail(record)} className="gx-link txtMax3LineHover">
                        {t(GLOBAL_CLIENT.detail)}
                     </span>
                     {(data_getUserInfo?.role == ROLES.ADMIN || data_getUserInfo?.role == ROLES.MANAGER_ORDER) &&
                        record.status === statusOrder.NEW && (
                           <>
                              <Divider type="vertical" />
                              <span onClick={() => handleAssign(record)} className="gx-link txtMax3LineHover">
                                 {t(GLOBAL_CLIENT.assignWarehouse)}
                              </span>
                           </>
                        )}
                     {/* {(data_getUserInfo?.role == ROLES.ADMIN ||
                     data_getUserInfo?.role == ROLES.MANAGER_ORDER ||
                     data_getUserInfo?.role == ROLES.FULFILLMENT) &&
                     record.status === statusOrder.ACCEPTED && (
                        <>
                           <Divider type="vertical" />
                           <span onClick={() => handleConfirmOrder(record)} className="gx-link txtMax2LineHover">
                              {'Xác nhận'}
                           </span>
                        </>
                     )} */}
                     {(data_getUserInfo?.role == ROLES.ADMIN ||
                        data_getUserInfo?.role == ROLES.MANAGER_ORDER ||
                        data_getUserInfo?.role == ROLES.FULFILLMENT) &&
                        record.status === statusOrder.ACCEPTED && (
                           <>
                              <Divider type="vertical" />
                              <span onClick={() => handleCancelOrder(record)} className="gx-link txtMax3LineHover">
                                 {'Huỷ'}
                              </span>
                           </>
                        )}
                     {(data_getUserInfo?.role == ROLES.ADMIN ||
                        data_getUserInfo?.role == ROLES.MANAGER_ORDER ||
                        data_getUserInfo?.role == ROLES.FULFILLMENT) &&
                        record.status === statusOrder.ACCEPTED && (
                           <>
                              <Divider type="vertical" />
                              <span onClick={() => handleCompleteOrder(record)} className="gx-link txtMax3LineHover">
                                 {'Hoàn thành'}
                              </span>
                           </>
                        )}
                     {(data_getUserInfo?.role === ROLES.ADMIN ||
                        data_getUserInfo?.role === ROLES.MANAGER_ORDER ||
                        data_getUserInfo?.role === ROLES.SELLER) &&
                        record.status === statusOrder.NEW &&
                        !record.storeId && (
                           <>
                              <Divider type="vertical" />
                              <span onClick={() => handleRemoveOrder(record.id)} className="gx-link txtMax3LineHover">
                                 {'Xóa'}
                              </span>
                           </>
                        )}
                     {/* {data_getUserInfo?.role !== ROLES.SELLER && (
                     <>
                        <Divider type="vertical" />
                        <span onClick={() => handleCancelOrder(record)} className="gx-link txtMax2LineHover">
                           {t(GLOBAL_CLIENT.huy)}
                        </span>
                     </>
                  )} */}
                     {(data_getUserInfo?.role === ROLES.ADMIN || data_getUserInfo?.role === ROLES.MANAGER_ORDER) &&
                        record.storeId &&
                        !record.saigonId &&
                        record.status === statusOrder.ACCEPTED && (
                           <>
                              <Divider type="vertical" />
                              <span onClick={() => handlePushOrder(record.id)} className="gx-link txtMax3LineHover">
                                 {'Đẩy đơn'}
                              </span>
                           </>
                        )}
                  </span>
               </>
            )
         }
      }
   ]

   if (data_getUserInfo?.role == ROLES.FULFILLMENT) {
      col3.splice(2, 0, {
         title: 'Order FF',
         dataIndex: 'statusFF',
         width: 80,
         key: 'statusFF',
         render: (value: any, record: any) => {
            return (
               <span style={{ marginLeft: -16 }}>
                  <Select
                     value={value}
                     style={{ minWidth: 75 }}
                     clearIcon
                     placeholder=""
                     onChange={handleUpdateStatus(record?.id)}
                  >
                     <Select.Option key={''} value={''}>
                        {''}
                     </Select.Option>
                     {((UserStore?.listConfigFF || '').split(',') || []).map((item: any) => {
                        return (
                           <Select.Option key={item} value={item}>
                              {item}
                           </Select.Option>
                        )
                     })}
                  </Select>
               </span>
            )
         }
      })
   }

   const handleDeleteItemFromList = () => {
      // console.log(selectedRow)
      setDataRow((pre: any) => {
         return pre.filter((item: any) => !selectedRow.find((it: any) => it.id === item.id))
      })

      setSelectedRow([])
   }

   const onChangePriority = (item: any, e: any, index: number) => {
      console.log('item: ', item, 'e', e, 'inde', index)
      // setRememberMe(e.target.checked)
      handlePriority(item, e.target.checked, index)
   }

   const renderPagination = () => {
      if (isEmpty(rows)) {
         return null
      }

      return (
         <div className="containerPagination" ref={paginationRef}>
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={OrdersStore.offsetList / PAGE_SIZE + 1}
               showSizeChanger={false}
               total={count}
            />
         </div>
      )
   }

   const handleFilterOperator = () => {
      setFieldFilter((prev: any) => {
         return { ...prev, ...{ operator, totalDelivery } }
      })
   }

   const handleClearFilterOperator = () => {
      setOperator('')
      setTotalDelivery(0)
      let x = { ...fieldFilter }
      delete x['operator']
      delete x['totalDelivery']
      setFieldFilter(x)
   }

   const handleRangePickerChange = (date: any) => {
      // set_dateRangerPicker(date);
      //  console.log('datee: ', date)
      OrdersStore.setStartTime(date[0])
      OrdersStore.setEndTime(date[1])
   }
   // rowSelection object indicates the need for row selection
   const rowSelection = {
      //@ts-ignore
      onChange: (selectedRowKeys, selectedRows) => {
         setSelectedRow(selectedRows)
      },
      //@ts-ignore
      getCheckboxProps: (record) => ({
         disabled:
            ((data_getUserInfo?.role == ROLES.ADMIN || data_getUserInfo?.role == ROLES.MANAGER_ORDER) &&
               record.status === statusOrder.ASSIGNEE) || // Column configuration not to be checked
            (data_getUserInfo?.role == ROLES.FULFILLMENT &&
               !data_getUserInfo?.isDelivery &&
               record.status !== statusOrder.ASSIGNEE)
      })
   }

   const handleChangeSeller = (value: any) => {
      console.log('value', value)
      if (value == fieldFilter.sellerId || !value) {
         let x = { ...fieldFilter }
         delete x['sellerId']
         setFieldFilter(x)
      } else {
         setFieldFilter({ ...fieldFilter, ...{ sellerId: value } })
      }
   }
   const handleChangeTrackingStatusName = (value: any) => {
      console.log('value', value)
      if (value == fieldFilter.tracking_status_name || !value) {
         let x = { ...fieldFilter }
         delete x['tracking_status_name']
         setFieldFilter(x)
      } else {
         setFieldFilter({ ...fieldFilter, ...{ tracking_status_name: value } })
      }
   }

   const handleChangeOperator = (value: any) => {
      setOperator(value)
   }

   const handleChangeFulfillment = (value: any) => {
      if (value == fieldFilter.fullfimentId || !value) {
         let x = { ...fieldFilter }
         delete x['fullfimentId']
         setFieldFilter(x)
      } else {
         setFieldFilter({ ...fieldFilter, ...{ fullfimentId: value } })
      }
   }

   const handleChangeTag = (value: any) => {
      if (value.length === 0) {
         let x = { ...fieldFilter }
         delete x['tagIds']
         setFieldFilter(x)
      } else {
         setFieldFilter({ ...fieldFilter, ...{ tagIds: value } })
      }
   }

   const getListStatusDelivery = useMemo(() => {
      switch (String(delivery)) {
         case 'atdsoftware':
            return ListStatusATG
         case 'ISO':
            return ListStatusISO

         case 'FW':
            return ListStatusFW

         default:
            return []
      }
   }, [delivery])

   const handleChangeStatus = (value: any) => {
      if (value.length === 0) {
         let x = { ...fieldFilter }
         delete x['statusFF']
         setFieldFilter(x)
      } else {
         setFieldFilter({ ...fieldFilter, ...{ statusFF: value } })
      }
   }

   const handleChangeDeliveryState = (valueTemp: any) => {
      let value = JSON.parse(valueTemp)
      if (value.length === 0) {
         let x = { ...fieldFilter }
         delete x['deliveryState']
         setFieldFilter(x)
      } else {
         console.log('====================================')
         console.log('{ ...fieldFilter, ...{ deliveryState: value } }', { ...fieldFilter, ...{ deliveryState: value } })
         console.log('====================================')
         setFieldFilter({ ...fieldFilter, ...{ deliveryState: value } })
      }
   }

   const handleChangeDelivery = (valueTemp: any) => {
      setDelivery(valueTemp)
      // if(!isEmpty(valueTemp)){
      setFieldFilter({ ...fieldFilter, ...{ dvvc: valueTemp } })
   }

   const handleUpdateStatus = (id: number) => async (value: any) => {
      console.log('id', id, value)

      await OrdersStore.updateStatusOrder(id, value)
   }
   return (
      <>
         <style>{`
            .order-filter-compact {
               width: 100%;
               padding: 6px 0 8px;
               margin-bottom: 8px;
               border-bottom: 0;
               background: transparent;
            }

            .order-filter-compact.row-container-head {
               margin-top: 0;
               margin-bottom: 8px;
            }

            .order-filter-compact .total-items {
               margin-bottom: 0;
            }

            .order-filter-row {
               display: flex;
               align-items: center;
               gap: 8px;
               width: 100%;
               min-width: 0;
            }

            .order-filter-row + .order-filter-row {
               margin-top: 5px;
            }

            .order-filter-row-main {
               justify-content: space-between;
            }

            .order-filter-search {
               flex: 0 0 460px;
               width: 460px;
               min-width: 260px;
               max-width: 460px;
               height: 32px !important;
            }

            .order-filter-main-actions {
               flex: 0 0 auto;
            }

            .order-filter-main-actions,
            .order-filter-controls,
            .order-filter-operator,
            .order-filter-status,
            .order-filter-order-status,
            .order-filter-summary,
            .order-filter-bulk-actions {
               display: flex;
               align-items: center;
               gap: 8px;
               min-width: 0;
            }

            .order-filter-controls {
               flex: 1 1 0;
               flex-wrap: nowrap;
            }

            .order-filter-operator {
               flex: 0 0 auto;
               flex-wrap: nowrap;
               margin-left: auto;
            }

            .order-filter-label {
               white-space: nowrap;
               font-size: 13px;
               font-weight: 600;
               color: #2f3650;
            }

            .order-filter-meta {
               justify-content: space-between;
               align-items: flex-start;
               gap: 12px;
            }

            .order-filter-status-wrap {
               display: flex;
               align-items: center;
               gap: 16px;
               flex: 1 1 auto;
               min-width: 0;
               flex-wrap: wrap;
            }

            .order-filter-summary {
               flex-wrap: wrap;
               color: #2f3650;
               font-size: 13px;
            }

            .order-filter-summary span {
               white-space: nowrap;
            }

            .order-filter-summary strong {
               font-weight: 700;
            }

            .order-filter-bulk-actions {
               flex: 0 0 auto;
               justify-content: flex-end;
               flex-wrap: nowrap;
            }

            .order-filter-compact .ant-input,
            .order-filter-compact .ant-input-search .ant-input,
            .order-filter-compact .order-filter-search .ant-input-affix-wrapper,
            .order-filter-compact .ant-input-search-button,
            .order-filter-compact .ant-picker,
            .order-filter-compact .ant-select-selector,
            .order-filter-compact .ant-input-number,
            .order-filter-compact .ant-btn {
               height: 32px !important;
               font-size: 13px;
            }

            .order-filter-compact .order-filter-search .ant-input-affix-wrapper {
               display: inline-flex;
               align-items: center;
               padding: 0 11px !important;
               line-height: 30px !important;
            }

            .order-filter-compact .ant-input-search .ant-input {
               height: 30px !important;
               padding-top: 4px !important;
               padding-bottom: 4px !important;
            }

            .order-filter-compact .ant-input-search .ant-input-group-addon {
               padding: 0 !important;
            }

            .order-filter-compact .ant-input-search .ant-input-search-button {
               width: 40px !important;
               padding: 0 !important;
            }

            .order-filter-compact .ant-input-group-addon {
               line-height: 30px !important;
            }

            .order-filter-compact .ant-input-search .ant-input,
            .order-filter-compact .ant-select-selection-item,
            .order-filter-compact .ant-select-selection-placeholder,
            .order-filter-compact .ant-input-number-input {
               line-height: 30px !important;
               font-size: 13px;
            }

            .order-filter-compact .ant-btn {
               display: inline-flex;
               align-items: center;
               justify-content: center;
               padding: 0 12px;
               margin: 0;
            }

            .order-filter-compact .ant-checkbox-wrapper {
               margin: 0;
               font-size: 13px;
               white-space: nowrap;
            }

            .order-filter-compact .ant-checkbox + span {
               padding-right: 0;
            }

            .order-filter-compact .ant-space,
            .order-filter-compact .ant-space-item {
               gap: 8px !important;
               margin: 0 !important;
            }

            .order-filter-main-actions > .ant-space {
               display: flex;
               align-items: center;
            }

            .order-filter-main-actions > .ant-space > .ant-space-item:has(> div[style*='display: none']) {
               display: none;
            }


            .order-product-list {
               display: flex;
               flex-direction: column;
            }

            .order-product-row {
               min-height: 86px;
               padding: 6px 0;
               display: flex;
               flex-direction: column;
               justify-content: center;
            }

            .order-product-name {
               margin-top: 4px;
               font-size: 10px;
            }

            .order-link-text {
               max-width: 210px;
               display: -webkit-box;
               -webkit-line-clamp: 3;
               -webkit-box-orient: vertical;
               overflow: hidden;
               word-break: break-all;
               line-height: 18px;
            }

            @media screen and (max-width: 991px) {
               .order-filter-row,
               .order-filter-row-main,
               .order-filter-meta,
               .order-filter-status-wrap {
                  flex-wrap: wrap;
               }

               .order-filter-search {
                  flex: 0 0 100%;
                  width: 100%;
                  max-width: none;
               }

               .order-filter-main-actions,
               .order-filter-controls,
               .order-filter-operator,
               .order-filter-bulk-actions {
                  flex-wrap: wrap;
                  margin-left: 0;
                  justify-content: flex-start;
               }

               .order-filter-main-actions {
                  display: grid;
                  grid-template-columns: repeat(2, minmax(0, 1fr));
                  width: 100%;
               }

               .order-filter-main-actions > .ant-picker {
                  grid-column: 1 / -1;
                  width: 100% !important;
               }

               .order-filter-main-actions > .ant-space {
                  display: contents;
               }

               .order-filter-main-actions > .ant-space > .ant-space-item,
               .order-filter-main-actions > .ant-btn {
                  width: 100%;
                  min-width: 0;
               }

               .order-filter-main-actions .ant-btn,
               .order-filter-main-actions .ant-space-item .ant-btn {
                  width: 100%;
               }

               .order-filter-controls {
                  width: 100%;
                  display: grid;
                  grid-template-columns: repeat(2, minmax(0, 1fr));
               }

               .order-filter-controls > .ant-select {
                  width: 100% !important;
                  min-width: 0;
               }

               .order-filter-operator {
                  display: grid;
                  grid-template-columns: auto minmax(0, 1fr) minmax(0, 0.7fr);
                  width: 100%;
               }

               .order-filter-operator > .ant-select,
               .order-filter-operator > .ant-input-number {
                  width: 100% !important;
                  min-width: 0;
               }

               .order-filter-operator > .ant-btn {
                  width: 100%;
               }

               .order-filter-status,
               .order-filter-order-status,
               .order-filter-summary {
                  flex-wrap: wrap;
               }
            }

            @media screen and (max-width: 575px) {
               .order-filter-compact {
                  padding-left: 8px;
                  padding-right: 8px;
               }

               .order-filter-main-actions,
               .order-filter-controls {
                  grid-template-columns: repeat(2, minmax(0, 1fr));
               }

               .order-filter-main-actions {
                  grid-template-columns: repeat(3, minmax(0, 1fr));
               }

               .order-filter-operator {
                  grid-template-columns: auto minmax(0, 1fr) minmax(0, 0.75fr);
               }

               .order-filter-operator > .ant-btn {
                  grid-column: span 1;
               }

               .order-filter-main-actions .ant-btn,
               .order-filter-main-actions .ant-space-item .ant-btn {
                  padding: 0 8px;
                  font-size: 12px;
               }
            }
         `}</style>
         <Loading isLoading={isLoading} />
         <Row>
            <Col span={24}>
               <div className="order-filter-compact row-container-head">
                  <div className="order-filter-row order-filter-row-main">
                     <Input.Search
                        className="order-filter-search"
                        value={textSearch}
                        onChange={(e: any) => set_textSearch(e?.target?.value ?? '')}
                        onSearch={handleChangeTextSearch}
                        // placeholder={t(GLOBAL_CLIENT.txtSearch)}
                        placeholder="Tên SP/TrackingId/Tên người nhận/OrderId/SellerOrderId"
                        allowClear
                        // onKeyDown={(event) => {
                        //    if (event.key === 'Enter') {
                        //       handleGetData()
                        //    }
                        // }}

                        ref={searchRef}
                     />
                     <div className="order-filter-main-actions text-right">
                        <DatePicker.RangePicker
                           allowClear={false}
                           defaultValue={[OrdersStore.startTime, OrdersStore.endTime]}
                           format={DATE_FORMAT_CLIENT}
                           locale={locale}
                           onChange={handleRangePickerChange}
                        />
                        {/* <Button className="btn-add" onClick={() => {}}>
                           {'Nhập CSV'}
                        </Button>
                        {data_getUserInfo?.role == ROLES.ADMIN && (
                           <Button className="btn-add" onClick={() => {}}>
                              {t(GLOBAL_CLIENT.exportCSV)}
                           </Button>
                        )} */}
                        <ExportToCSV from={OrdersStore.startTime} to={OrdersStore.endTime} />
                        {data_getUserInfo.role !== ROLES.FULFILLMENT && (
                           <Button type="primary" className="btn-add" onClick={() => setVisibleCreate(true)}>
                              {t(GLOBAL_CLIENT.create)}
                           </Button>
                        )}
                     </div>
                  </div>

                  <div className="order-filter-row total-items">
                     <div className="order-filter-controls">
                        {data_getUserInfo.role !== ROLES.SELLER && data_getUserInfo.role !== ROLES.FULFILLMENT && (
                           <Select
                              value={fieldFilter.sellerId}
                              clearIcon
                              showSearch
                              style={{ width: 140 }}
                              placeholder="Chọn seller"
                              onChange={handleChangeSeller}
                              allowClear
                              filterOption={(input: string, option: any) =>
                                 option?.children?.toLowerCase().includes(input.toLowerCase())
                              }
                           >
                              <Select.Option key={''} value={''}>
                                 {'Tất cả'}
                              </Select.Option>
                              {listSeller.map((item: any, index: number) => {
                                 return (
                                    <Select.Option key={index} value={item?.id}>
                                       {item?.name}
                                    </Select.Option>
                                 )
                              })}
                           </Select>
                        )}
                        {data_getUserInfo.role !== ROLES.SELLER && data_getUserInfo.role !== ROLES.FULFILLMENT && (
                           <Select
                              value={fieldFilter.fulfillmentId}
                              clearIcon
                              placeholder="Chọn fulfillment"
                              onChange={handleChangeFulfillment}
                              style={{ width: 145 }}
                           >
                              <Select.Option key={''} value={''}>
                                 {'Tất cả'}
                              </Select.Option>
                              {listFulfillment.map((item: any) => {
                                 return (
                                    <Select.Option key={item?.id} value={item?.id}>
                                       {item?.name}
                                    </Select.Option>
                                 )
                              })}
                           </Select>
                        )}
                        {data_getUserInfo.role !== ROLES.SELLER && data_getUserInfo.role !== ROLES.FULFILLMENT && (
                           <Select
                              value={fieldFilter.tagIds}
                              mode="multiple"
                              clearIcon
                              placeholder="Chọn Tag"
                              onChange={handleChangeTag}
                              style={{ width: 160 }}
                           >
                              <Select.Option key={''} value={''}>
                                 {'Tất cả'}
                              </Select.Option>
                              {tags.map((item: any) => {
                                 return (
                                    <Select.Option key={item?.id} value={item?.id}>
                                       {item?.name}
                                    </Select.Option>
                                 )
                              })}
                           </Select>
                        )}
                        {data_getUserInfo.role === ROLES.FULFILLMENT && (
                           <Select
                              value={fieldFilter.tagIds}
                              clearIcon
                              placeholder="All"
                              onChange={handleChangeStatus}
                              style={{ width: 160 }}
                           >
                              <Select.Option key={''} value={''}>
                                 {'Tất cả'}
                              </Select.Option>
                              {((UserStore?.listConfigFF || '').split(',') || []).map((item: any) => {
                                 return (
                                    <Select.Option key={item} value={item}>
                                       {item}
                                    </Select.Option>
                                 )
                              })}
                           </Select>
                        )}
                        {(data_getUserInfo.role === ROLES.FULFILLMENT && data_getUserInfo?.isDelivery) ||
                           (data_getUserInfo.role === ROLES.ADMIN && (
                              <Select
                                 value={delivery || undefined}
                                 showSearch
                                 allowClear
                                 placeholder="Tìm DVVC"
                                 filterOption={(input, option) =>
                                    (option?.children as unknown as string)
                                       ?.toLowerCase()
                                       ?.includes(input.toLowerCase())
                                 }
                                 onChange={(val: any) => {
                                    const v = val || ''
                                    setDelivery(v)
                                    handleChangeDelivery(v)
                                 }}
                                 style={{ width: 155 }}
                              >
                                 <Select.Option value={''}>{'All'}</Select.Option>
                                 {(deliveryOptions || []).map((item: any, index) => {
                                    return (
                                       <Select.Option key={index} value={item?.value}>
                                          {item?.label}
                                       </Select.Option>
                                    )
                                 })}
                              </Select>
                           ))}
                        {data_getUserInfo.role === ROLES.FULFILLMENT && data_getUserInfo?.isDelivery && delivery && (
                           <Select
                              value={JSON.stringify(fieldFilter.deliveryState)}
                              clearIcon
                              placeholder="All"
                              onChange={handleChangeDeliveryState}
                              style={{ width: 155 }}
                           >
                              {getListStatusDelivery.map((item: any, index) => {
                                 return (
                                    <Select.Option key={index} value={JSON.stringify(item?.value)}>
                                       {item?.label}
                                    </Select.Option>
                                 )
                              })}
                           </Select>
                        )}
                        {
                           <Select
                              value={fieldFilter.tracking_status_name}
                              clearIcon
                              showSearch
                              style={{ width: 145 }}
                              placeholder="Tracking status"
                              onChange={handleChangeTrackingStatusName}
                              allowClear
                              filterOption={(input: string, option: any) =>
                                 option?.children?.toLowerCase().includes(input.toLowerCase())
                              }
                           >
                              <Select.Option key={''} value={''}>
                                 {'Tất cả'}
                              </Select.Option>
                              {TRACKING_STATUS_NAME.map((item: any, index: number) => {
                                 return (
                                    <Select.Option key={`${item.id}`} value={item.id}>
                                       {item.value}
                                    </Select.Option>
                                 )
                              })}
                           </Select>
                        }
                     </div>
                     {data_getUserInfo.role != ROLES.SELLER && (
                        <div className="order-filter-operator total-items">
                           <span className="order-filter-label">{'Toàn trình'}</span>
                           <Select
                              value={operator}
                              clearIcon
                              showSearch
                              style={{ width: 130 }}
                              placeholder="Toán tử"
                              onChange={handleChangeOperator}
                              allowClear
                              filterOption={(input: string, option: any) =>
                                 option?.children?.toLowerCase().includes(input.toLowerCase())
                              }
                           >
                              <Select.Option key={''} value={''}>
                                 {'Tất cả'}
                              </Select.Option>
                              {OPERATOR.map((item: any, index: number) => {
                                 return (
                                    <Select.Option key={`${item}`} value={item}>
                                       {item}
                                    </Select.Option>
                                 )
                              })}
                           </Select>
                           <InputNumber
                              min={0}
                              style={{ width: 82 }}
                              placeholder="Số ngày"
                              value={totalDelivery}
                              onChange={(value) => {
                                 setTotalDelivery(Number(value))
                              }}
                           />

                           <Button onClick={handleFilterOperator} type="primary">
                              {'Tìm kiếm'}
                           </Button>
                           <Button onClick={handleClearFilterOperator} type="ghost">
                              {'Clear'}
                           </Button>
                        </div>
                     )}
                  </div>

                  <div className="order-filter-row order-filter-meta total-items">
                     <div className="order-filter-status-wrap">
                        <div className="order-filter-status">
                           <span className="order-filter-label">{'Status Tracking:'}</span>
                           <Checkbox defaultChecked={true} onChange={(e) => onChangeStatus(STATUS_ACTIVITY.NEW, e)}>
                              {'Mới'}
                           </Checkbox>
                           <Checkbox defaultChecked={true} onChange={(e) => onChangeStatus(STATUS_ACTIVITY.DOING, e)}>
                              {'Đang xử lí'}
                           </Checkbox>
                           <Checkbox defaultChecked={false} onChange={(e) => onChangeStatus(STATUS_ACTIVITY.REVIEW, e)}>
                              {'Huỷ'}
                           </Checkbox>
                        </div>
                        <div className="order-filter-order-status">
                           <Checkbox defaultChecked={true} onChange={(e) => onChangeStatus(statusOrder.NEW, e)}>
                              {getStatusOrder(statusOrder.NEW)}
                              {/* {'Chờ xác nhận'} */}
                           </Checkbox>
                           <Checkbox defaultChecked={true} onChange={(e) => onChangeStatus(statusOrder.ACCEPTED, e)}>
                              {getStatusOrder(statusOrder.ACCEPTED)}
                              {/* {'Đang xử lí'} */}
                           </Checkbox>
                           {/* <Checkbox
                        style={{ paddingLeft: 4, paddingRight: 4 }}
                        defaultChecked={true}
                        onChange={(e) => onChangeStatus(statusOrder.ACCEPTED, e)}
                     >
                        {getStatusOrder(statusOrder.ACCEPTED)}
                     </Checkbox> */}
                           <Checkbox defaultChecked={true} onChange={(e) => onChangeStatus(statusOrder.CANCEL, e)}>
                              {getStatusOrder(statusOrder.CANCEL)}
                           </Checkbox>
                           <Checkbox defaultChecked={true} onChange={(e) => onChangeStatus(statusOrder.FINISH, e)}>
                              {getStatusOrder(statusOrder.FINISH)}
                           </Checkbox>
                        </div>
                        <div className="order-filter-summary">
                           <span>
                              {t(GLOBAL_CLIENT.totalItems)}: <strong>{dataRow.length}</strong>
                           </span>
                           {selectedRow && selectedRow.length > 0 && (
                              <Button className="btn-add" onClick={handleDeleteItemFromList} type="primary" color="red">
                                 {'Xoá khỏi danh sách'}
                              </Button>
                           )}
                        </div>
                     </div>

                     <div className="gx-d-flex order-filter-bulk-actions">
                        {data_getUserInfo?.role == ROLES.FULFILLMENT &&
                           data_getUserInfo?.isDelivery &&
                           selectedRow &&
                           selectedRow.length > 0 && (
                              <Button
                                 className="btn-add"
                                 onClick={() => {
                                    setVisibleAssignStatusFF(true)
                                 }}
                                 type="primary"
                              >
                                 {'Update Status FF'}
                              </Button>
                           )}
                        {selectedRow && selectedRow.length > 0 && (
                           <Button className="btn-add" onClick={handlePrintLabel} type="primary">
                              {'In Label'}
                           </Button>
                        )}
                        {data_getUserInfo?.role == ROLES.SELLER && selectedRow && selectedRow.length > 0 && (
                           <Button className="btn-add" onClick={handleExportExcel} type="primary">
                              {'Export Excel'}
                           </Button>
                        )}
                        {(data_getUserInfo?.role == ROLES.ADMIN || data_getUserInfo?.role == ROLES.MANAGER_ORDER) &&
                           selectedRow &&
                           selectedRow.length > 0 && (
                              <Button className="btn-add" onClick={handleAssignSelected} type="primary">
                                 {'Gán kho'}
                              </Button>
                           )}
                        {(data_getUserInfo?.role == ROLES.ADMIN || data_getUserInfo?.role == ROLES.MANAGER_ORDER) &&
                           selectedRow &&
                           selectedRow.length > 0 && (
                              <Button className="btn-add" onClick={handlePushSelected} type="dashed">
                                 {'Đẩy đơn'}
                              </Button>
                           )}
                        {data_getUserInfo?.role == ROLES.FULFILLMENT &&
                           data_getUserInfo?.isDelivery &&
                           selectedRow &&
                           selectedRow.length > 0 && (
                              <Button className="btn-add" onClick={handleAssignDVVCSelected} type="primary">
                                 {'Gán DVVC'}
                              </Button>
                           )}
                        {data_getUserInfo?.role == ROLES.FULFILLMENT &&
                           data_getUserInfo?.isDelivery &&
                           selectedRow &&
                           selectedRow.length > 0 && (
                              <Button className="btn-add" onClick={handlePrint} type="primary">
                                 {'In đơn'}
                              </Button>
                           )}
                        {/* {data_getUserInfo?.role == ROLES.FULFILLMENT &&
                        data_getUserInfo?.isDelivery &&
                        selectedRow &&
                        selectedRow.length > 0 && (
                           <Button className="btn-add" onClick={handleAssignDelivery} type="primary">
                              {'Đẩy vận chuyển'}
                           </Button>
                        )} */}

                        {data_getUserInfo?.role == ROLES.FULFILLMENT && selectedRow && selectedRow.length > 0 && (
                           <Button className="btn-add" onClick={handleConfirmOrder} type="primary">
                              {'Xác nhận'}
                           </Button>
                        )}
                     </div>
                  </div>
               </div>

               <div ref={tableWrapperRef}>
                  <Table
                     scroll={{ x: 1500, y: scrollY }}
                     columns={[...columns, ...col2, ...colDelivery, ...col3]}
                     dataSource={dataRow}
                     rowKey="id"
                     rowSelection={rowSelection}
                     pagination={false}
                  />
               </div>

               {/* {renderPagination()} */}
            </Col>
         </Row>

         {visibleCreate && (
            <CreateOrder
               visible={visibleCreate}
               onOk={() => handleOrderCreator()}
               onCancel={() => setVisibleCreate(false)}
               onShowProducts={() => setVisibleProductModal(true)}
            />
         )}

         {visibleProductModal && (
            <SelectProductModal
               visible={visibleProductModal}
               onOk={() => setVisibleProductModal(false)}
               onCancel={() => setVisibleProductModal(false)}
            />
         )}
         {visibleDetail && selectedItem && (
            <CreateOrder
               onlyView
               visible={visibleDetail}
               item={selectedItem}
               onOk={() => handleOrderCreator(true)}
               fieldFilter={fieldFilter}
               textSearch={textSearch}
               onCancel={hideDetail}
               onShowProducts={() => setVisibleProductModal(true)}
               onRemove={(id: string) => handleRemoveOrder(id)}
               onReloadData={fetchListData}
            />
         )}

         {visibleDetailDelivery && (
            <DeliveryDetailScreen
               onlyView
               visible={visibleDetailDelivery}
               item={selectedItem[0]}
               onOk={() => handleOrderCreator(true)}
               fieldFilter={fieldFilter}
               textSearch={textSearch}
               onCancel={() => {
                  setVisibleDetailDelivery(false)
                  setSelectedItem([])
               }}
               onShowProducts={() => setVisibleProductModal(true)}
               onRemove={(id: string) => handleRemoveOrder(id)}
               onReloadData={fetchListData}
            />
         )}

         {visibleDeliveryRouting && (
            <DeliveryRoutingScreen
               onlyView
               visible={visibleDeliveryRouting}
               item={selectedItem}
               onOk={() => handleOrderCreator(true)}
               fieldFilter={fieldFilter}
               textSearch={textSearch}
               onCancel={() => {
                  setVisibleDeliveryRouting(false)
                  setSelectedItem([])
               }}
               onShowProducts={() => setVisibleProductModal(true)}
               onRemove={(id: string) => handleRemoveOrder(id)}
               onReloadData={fetchListData}
            />
         )}

         {visibleAssignWarehouse && (
            <AssignWarehouse
               item={selectedRow}
               visible={visibleAssignWarehouse}
               onOk={handleAssignWarehouse}
               onCancel={() => setVisibleAssignWarehouse(false)}
            />
         )}
         {visibleAssignDVVC && (
            <AssignDVVC
               item={selectedRow}
               visible={visibleAssignDVVC}
               onOk={handleAssignDVVC}
               onCancel={() => setVisibleAssignDVVC(false)}
            />
         )}
         {visibleAssignStatusFF && (
            <UpdateStatusFF
               item={selectedRow}
               visible={visibleAssignStatusFF}
               onOk={handleAssignStatusFF}
               onCancel={() => setVisibleAssignStatusFF(false)}
            />
         )}
         <div style={{ marginTop: 20, display: 'none' }}>
            <LabelPrint ref={contentRef} data={selectedRow} />
         </div>
      </>
   )
})

export default OrderManagement
